import {
  ALL_VENDOR_FAIL,
  ALL_VENDOR_REQUEST,
  ALL_VENDOR_SUCCESS,
  CLEAR_ERRORS,
} from "../constants/vendorConstants";

export const vendorReducer = (state = { vendor: [] }, action) => {
  switch (action.type) {
    case ALL_VENDOR_REQUEST:
      return {
        loading: true,
        vendor: [],
      };
    case ALL_VENDOR_SUCCESS:
      return {
        loading: false,
        vendor: action.payload,
      };
    case ALL_VENDOR_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
